import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
    selector: 'app-filtros-flotante',
    templateUrl: './filtros-flotante.component.html',
    styleUrl: './filtros-flotante.component.scss',
    standalone: false
})
export class FiltrosFlotanteComponent {
    constructor() {}
    @Input() formulario!: FormGroup; // Desde el padre
    /**
     * Definicion de filtros, en componente padre determinamos que tipo de filtros usamos
     * *Listas verificación -> colapsable(grupoDeFiltros)
     */
    @Input() filtros: any[] = [];
    @Input() gruposDeFiltros: {
        titulo?: string;
        colapsable?: boolean;
        filtros: any[];
    }[] = [];

    @Input() opcionesSelect: Record<string, any[]> = {};
    @Output() aplicar = new EventEmitter<void>();

    mostrarDialogo = false;

    abrirDialogo() {
        this.mostrarDialogo = true;
    }

    cerrarDialogo() {
        this.mostrarDialogo = false;
    }

    aplicarFiltros() {
        this.aplicar.emit();
        this.cerrarDialogo();
    }

    obtenerOpciones(campo: string): any[] {
        return this.opcionesSelect[campo] || [];
    }
}
